var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-click=\"$event.stopPropagation()\" style=\"position:absolute !important;top:50% !important;left:50% !important;transform:translate(-50%,-50%) !important;width:600px;max-width:90%;z-index:1050;border:2px solid #5c6bc0;box-shadow:0 2px 16px rgba(0,0,0,0.25);\" class=\"c-modal is-active\"><div style=\"font-weight:bold;\" class=\"c-modal__header\">{{ 'accessRequestTitle' | translate }}</div><div class=\"c-modal__body\"><p>{{ 'accessRequestMessage' | translate:vm.msgParams }}</p><p>{{ 'grantAccessQuestion' | translate }}</p></div><div class=\"c-modal__footer text-right\"><button ng-click=\"vm.close(false)\" class=\"o-btn c-btn c-btn--secondary\">{{ 'cancel' | translate:'{ value: \"\" }' }}</button><button ng-click=\"vm.close(&quot;reject&quot;)\" class=\"o-btn c-btn c-btn--danger\">{{ 'reject' | translate }}</button><button ng-click=\"vm.close(&quot;approve&quot;)\" class=\"o-btn c-btn c-btn--outlined\">{{ 'approve' | translate }}</button></div></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/admin/users/accessRequestApprovalModal.jade
 ** module id = 648
 ** module chunks = 0
 **/